import React from "react";
import "../styles/styles.css";

const Footer = ({ currentYear = new Date().getFullYear() }) => {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <img src="/zarkit-z.png" alt="Zarkit logo" className="footer-logo" />
          <div>
            <strong>Zarkit</strong>
            <span>
              Powered by Zarkit Group. Transport support for business and
              personal goods movement in Jhansi.
            </span>
          </div>
        </div>

        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/#about">About</a>
          <a href="/#vehicles">Vehicles</a>
          <a href="/#bulk-order">Bulk Order</a>
          <a href="/#contact">Contact</a>
        </div>

        <p className="footer-copy">
          Copyright (c) {currentYear} Zarkit Group. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
